import { __decorate } from "tslib";
import { Component, Vue } from 'vue-property-decorator';
import NotificationCard from '@/views/components/notification/NotificationCard.vue';
import OrganizationCard from '@/views/components/organization/OrganizationCard.vue';
import NotificationRepository from '@/services/repository/NotificationRepository';
import UserSettingsRepository from '@/services/repository/UserSettingsRepository';
import DateTimeManager from '@/services/DateTimeManager';
import DepartmentRepository from '@/services/repository/DepartmentRepository';
import { DepartmentArray } from '@/entities/models/arrayModels/DepartmentArray';
import LoggedUserManager from '@/services/LoggedUserManager';
import { AdminDepartment } from '@/entities/models/AdminDepartment';
import VueUtilities from '@/services/VueUtilities';
import { UserSettingsKeys } from '@/entities/enums/UserSettingKeys';
import { vxm } from '@/store/store.vuex';
import InvitationCard from '@/views/components/invitation/InvitationCard.vue';
import UserRepository from '@/services/repository/UserRepository';
import AppConfig from '@/configLoader';
import CommonSettingsModal from '../components/common/CommonSettingsModal.vue';
const MAX_RECENT_NOTIFICATIONS = 5;
var notificationRepository;
var userSettingsRepository;
var departmentRepository;
var userRepository;
var vxDepartmentStore = vxm.departmentStore;
var vxNotificationStore = vxm.notificationStore;
let OrgHomePage = class OrgHomePage extends Vue {
    constructor() {
        super(...arguments);
        this.notifications = [];
        this.notificationsCount = 0;
        this.pauseNotificationsUntil = 0;
        this.favoriteDepartmentId = null;
        this.dateTimeManager = null;
        this.departments = new DepartmentArray([]);
        this.invitations = [];
        this.deptId = null;
        this.tableAdminCompanyQueries = 'adminCompany';
        this.objStringAdminCompany = null;
        this.isRefreshOn = true;
        this.isOpenRefreshSettingsModal = false;
        this.refreshIntervalHandler = null;
        this.currentFilters = [];
        this.isLoading = {
            OrganizationCard: true,
            NotificationCard: true,
            InvitationCard: true
        };
        this.eventsRefreshInterval = 0;
    }
    get notificationsPaused() {
        let now = Math.floor(new Date().getTime() / 1000);
        return this.pauseNotificationsUntil > now;
    }
    get isAdmin() {
        return LoggedUserManager.isAdmin();
    }
    /**
     * Check config if feature is On.
     */
    get addAdminToDepartmentIsTurnedOn() {
        return AppConfig.getConfig().features.adminInDepartment == true;
    }
    async created() {
        this.dateTimeManager = await DateTimeManager.CreateManager(this);
        notificationRepository = new NotificationRepository(this);
        departmentRepository = new DepartmentRepository(this);
        userSettingsRepository = UserSettingsRepository.getInstance(this);
        userRepository = new UserRepository(this);
        await this.loadDataForPage();
        if (this.$route.query?.deptId) {
            this.deptId = this.$route.query?.deptId.toString();
            const element = document.getElementById('invitation');
            element.scrollIntoView({ behavior: 'smooth' });
        }
    }
    async loadDataForPage() {
        let allPromises = [];
        allPromises.push(this.loadNotifications());
        allPromises.push(userSettingsRepository.loadUserSettings());
        allPromises.push(userRepository.getInvitationsList());
        await Promise.all(allPromises).then((response) => {
            this.processLoadedDataForPage(response[1], response[2]);
        });
    }
    async processLoadedDataForPage(settings, invitations) {
        this.loadNotificationsConfig();
        this.pauseNotificationsUntil = parseInt(settings.notifications.pause.until);
        this.favoriteDepartmentId = settings.preferences.favoriteDepartmentId;
        this.eventsRefreshInterval = AppConfig.getConfig().attributes.events_refresh_interval;
        this.isRefreshOn = settings.preferences.statusPageRefreshEnabled === 'true';
        this.invitations = invitations.filter((x) => Date.now() <= x.validUntil * 1000);
        if (!this.isAdmin) {
            await this.loadUserCompanies();
        }
        this.controlRefresh();
        this.isLoading.InvitationCard = false;
        this.isLoading.OrganizationCard = false;
        this.isLoading.NotificationCard = false;
    }
    async assignDepartmentIssueSummariesForUser(departments) {
        let depIssuesSummaries = await departmentRepository.getDepartmentIssues();
        let depArr = departments.getData();
        depArr.forEach((dep) => {
            let issuesSummary = depIssuesSummaries.find((summary) => summary.id === dep.id);
            dep.issuesSummary = issuesSummary ? issuesSummary.issues : [];
        });
        departments.setData(depArr);
        vxDepartmentStore.departments = depArr;
        return departments;
    }
    async loadUserCompanies() {
        let resp = await departmentRepository.getDepartments();
        this.departments = await this.assignDepartmentIssueSummariesForUser(resp.getData());
    }
    async loadAdminCompanies(currentFilters) {
        this.currentFilters = currentFilters;
        let resp = await departmentRepository.getAllDepartmentsAdmin(null, null, this.currentFilters);
        this.departments = AdminDepartment.convertToDepartmentsArray(resp.getData());
    }
    async refreshChanged(value) {
        this.isOpenRefreshSettingsModal = false;
        this.isRefreshOn = value;
        await userSettingsRepository.saveUserSettings([[UserSettingsKeys.PREFERENCES, UserSettingsKeys.STATUS_PAGE_REFRESH]], [value.toString()]);
        this.controlRefresh();
    }
    openRefreshSettingsModal() {
        this.isOpenRefreshSettingsModal = true;
    }
    closeRefreshSettingsModal() {
        this.isOpenRefreshSettingsModal = false;
    }
    loadNotificationsConfig() {
        this.notifications = vxNotificationStore.notifications;
        this.notificationsCount = vxNotificationStore.totalSize;
    }
    controlRefresh() {
        if (this.isRefreshOn) {
            //check if interval is not created already
            if (!this.refreshIntervalHandler)
                this.refreshIntervalHandler = setInterval(this.loadAdditionalData, this.eventsRefreshInterval);
        }
        else {
            clearInterval(this.refreshIntervalHandler);
        }
    }
    beforeDestroy() {
        clearInterval(this.refreshIntervalHandler);
    }
    async loadAdditionalData() {
        if (!this.isAdmin) {
            await this.loadUserCompanies();
        }
        else {
            await this.loadAdminCompanies(this.currentFilters);
        }
    }
    async loadNotifications() {
        let pagination = {
            page: 1,
            pageSize: MAX_RECENT_NOTIFICATIONS
        };
        return notificationRepository.loadNotificationsToStore(pagination);
    }
    async notificationRemoved(notifIds) {
        await notificationRepository.markNotificationsAsRead(notifIds);
        vxNotificationStore.clearData();
        await this.loadNotifications();
        this.loadNotificationsConfig();
    }
    async favoriteSelected(id) {
        await userSettingsRepository.saveUserSettings([[UserSettingsKeys.PREFERENCES, UserSettingsKeys.FAVORITE_DEPARTMENT_ID]], [id]);
        VueUtilities.openSuccessToast(this, this.$t('component.settings.administration.update_success'));
        this.favoriteDepartmentId = id;
        vxDepartmentStore.setSelectedDepartmentById(id);
    }
    async acceptInvite(invitationId) {
        if (LoggedUserManager.isAdmin() && this.addAdminToDepartmentIsTurnedOn == false) {
            VueUtilities.openErrorToast(this, this.$t('component.invitation.admin_cannot_accept'));
            return;
        }
        else {
            await userRepository.acceptInvitation(invitationId);
            VueUtilities.openSuccessToast(this, this.$t('component.invitation.accept_success'));
            this.loadDataForPage();
        }
    }
    async declineInvite(invitationId) {
        await userRepository.declineInvitation(invitationId);
        VueUtilities.openSuccessToast(this, this.$t('component.invitation.decline_success'));
        this.loadDataForPage();
    }
    changeRouterUrlFromCompany(objStringAdminCompany) {
        this.objStringAdminCompany = objStringAdminCompany;
        this.changeRouterUrl(this.objStringAdminCompany);
    }
    changeRouterUrl(objStringAdminCompany) {
        this.$router
            .push({
            query: {
                [this.tableAdminCompanyQueries]: objStringAdminCompany
            }
        })
            .catch((err) => err);
    }
};
OrgHomePage = __decorate([
    Component({
        components: {
            InvitationCard,
            OrganizationCard,
            NotificationCard,
            CommonSettingsModal
        }
    })
], OrgHomePage);
export default OrgHomePage;
